/**
 * FE-086. The zoom ceiling for maps that open on `bounds` (MapView on the dashboard and Devices > Map,
 * MapDeviceTrack on Devices > Track).
 *
 * WHY IT MUST BE SET ON THE MAP. With no positions yet, both maps fall back to ONE default point, and
 * Leaflet's fitBounds on a single point returns zoom Infinity unless the MAP has a maxZoom option (it
 * clamps to map.options.maxZoom, not to the layers' limits). Adding the tile layer then clamps it to 18
 * through `_updateZoomLevels` -> `setZoom(18)` -> `getCenter()`. If the map pane has moved at all by then,
 * getCenter computes from the Infinity-zoom pixel origin and throws "Invalid LatLng object: (NaN, NaN)".
 * With no error boundary, that blanked the whole dashboard on about half of hard loads (2026-09-24, local).
 *
 * 18 is the tile layer's own default maxZoom, which is the zoom the maps already ended on after that clamp,
 * so this changes no visible zoom. True for Leaflet 1.9.4; if Leaflet starts clamping fitBounds to layer
 * limits, this becomes redundant rather than wrong.
 */
export const MAP_MAX_ZOOM = 18
